module.exports = __webpack_public_path__ + "img/hexa_red.284449ba.png";